import React, { useEffect } from 'react';
import config from '../../config.json';
import axios from 'axios';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { useParams } from "react-router-dom";
import styled from 'styled-components';
import { Button, } from '@mui/material';
import { FilterInput } from '../../../shared/components/FilterInput';
import { useNavigate } from 'react-router-dom';
import { TextField, Autocomplete, Grid } from '@mui/material'
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteIcon from '@mui/icons-material/Delete';

const TableWrapper = styled.div`
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
         background-color: #F59300 !important;
    }
   
    .materialTableStyle {
        .filterAutocomplete{
    
            .closeIcon { 
                position: absolute;
                left: 450px;
                right: 0px;
                top: 20px;
                bottom: 0px;
            }
            .MuiFilledInput-root {
                background-color: #ffffff;
                border-radius: 0;
                height : 35px;
                padding-top : 0px;
            }
            .MuiFilledInput-input {
                padding: none;
                font-size: 12px;
                height : 10px;
            }
            .MuiFilledInput-underline:before {
                border: 0;
            }
            .MuiInputLabel-filled {
                transform: translate(12px,7px) scale(1);
                font-size: 12px;
            }
            .MuiFilledInput-underline:after {
                border: 0;
            }
            .MuiSelect-select:focus {
                background-color: #ffffff;
            }
            .MuiInputLabel-filled.MuiInputLabel-shrink {
                transform: translate(0px,-12px) scale(0.90) !important;
                color: #F59300;
            }}
        table {
            border-collapse: separate;
            border-spacing: 0 1em;
            width: 99%;
            margin: auto;
        }
        th:first-child, td:first-child {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
        }
        th:last-child, td:last-child {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
        }
        th {
            font-size: 12px !important;
            white-space: nowrap;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            color: #F59300;
            height: 55px;
        }
        .MuiTableSortLabel-active {
            color: #F59300;
        }
        .MuiTableSortLabel-root:hover {
            color: #F59300;
        }
        .MuiTableSortLabel-icon {
            color: #F59300 !important;
        }
        td {
            position: relative;
            font-size: 12px !important;
            color: #000;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            height: 60px;
        }
        tbody {
            tr {
                position: relative;
                border-radius: 15px;
                transition: all 0.3s linear;
              
                &:hover {
                    box-shadow: 0 10px 6px rgba(0,0,0,0.10), 0 6px 3px rgba(0,0,0,0.10);
                    .actionListEditIconPosition {
                        display: block;
                    }
                    .actionListDeleteIconPosition {
                        display: block;
                    }
                    .actionApproveIconPosition{
                        display: block;
                    }
                    .actionRejectIconPosition{
                        display: block;
                    }
                }
            }
        }
        .actionListDeleteIconPosition {
            position: absolute;
            top: -16px;
            right: 15px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListEditIconPosition {
            position: absolute;
            top: -16px;
            right: 97px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionApproveIconPosition{
            position: absolute;
            top: -16px;
            right: 56px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionRejectIconPosition{
            position: absolute;
            top: -16px;
            right: 15px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionBtn {
            padding: 8px;
            background-color: #ffffff;
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

            &:hover {
                background-color: rgba(245,147,0,0.1);
                color: #F59300;
            }
        }
        .actionIcon {
            font-size: 17px;
        }
        .approveActionIcon {
            font-size: 17px;
            font-weight : 1500px ;
        }
    }
    .filterRow {
        display: grid;
        grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr 1fr;
        background-color: rgba(245, 147, 0, 0.1);
        height: 60px;
        border-radius: 15px;
        align-items: center;
        grid-column-gap: 10px;
        padding-left: 10px;
        padding-right: 10px;
        width: 99%;
        margin: auto;
    }
    .filterIconSize{
        font-size: 18px;
    }
    .filterDropdown {
        .MuiFilledInput-root {
            background-color: #ffffff;
            border-radius: 0;
        }
        .MuiFilledInput-input {
            padding: 5px 10px 5px;
            font-size: 12px;
        }
        .MuiFilledInput-underline:before {
            border: 0;
        }
        .MuiInputLabel-filled {
            transform: translate(12px,7px) scale(1);
            font-size: 12px;
        }
        .MuiFilledInput-underline:after {
            border: 0;
        }
        .MuiSelect-select:focus {
            background-color: #ffffff;
        }
        .MuiInputLabel-filled.MuiInputLabel-shrink {
            transform: translate(0px,-12px) scale(0.90) !important;
            color: #F59300;
        }
       
    }
`;

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'dispatchDate', numeric: false, label: 'Dispatch Date' },
    { id: 'siteName', numeric: false, label: 'Project Site Name' },
    { id: 'userName', numeric: false, label: 'User/Group Name' },
    { id: 'formName', numeric: false, label: 'Form Name' },
    { id: 'pfDataId', numeric: false, label: 'TC Reference' }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

export default function Dispatches() {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    var [rows, setRows] = React.useState([]);
    var [filteredRows, setFilteredRows] = React.useState([]);
    var [disable, setDisable] = React.useState(true);
    const token = config.TOKEN
    const { id } = useParams();
    var [userEmail, setUserEmail] = React.useState("");
    var [userName, setUserName] = React.useState("");
    var [userProfile, setUserProfile] = React.useState();
    const currentDate = moment();
    const [startDate, setStartDate] = React.useState(currentDate.clone().startOf('month').format("yyyy-MM-DD"));
    const [endDate, setEndDate] = React.useState(currentDate.clone().endOf('month').format("yyyy-MM-DD"));
    var [userData, setUserData] = React.useState([]);
    var [siteData, setSiteData] = React.useState([]);
    var [routeData, setRouteData] = React.useState([]);
    var [userId, setUserId] = React.useState(null);
    var [routeId, setRouteId] = React.useState(null);
    var [siteId, setSiteId] = React.useState(null);
    var [scheduleId, setScheduleId] = React.useState();
    var [approvePopup, setApprovePopup] = React.useState(false);
    var [deletePopup, setDeletePopup] = React.useState(false);
    var [recordId, setRecordId] = React.useState();
    const navigate = useNavigate();
    const errorMessage = () => toast("An error occured,try again later", { progressClassName: classes.customToastProgress });
    const approveMessage = () => toast("Form Approved Successfully!", { progressClassName: classes.customToastProgress });
    const rejectMessage = () => toast("Form Rejected Successfully!", { progressClassName: classes.customToastProgress });
    const deleteMessage = () => toast("Dispatch deleted successfully!", { progressClassName: classes.customToastProgress });
    const errorContactMessage = () => toast("An error occured, contact support", { progressClassName: classes.customToastProgress });

    useEffect(() => {
        userProfile = localStorage.getItem("userProfile");
        userProfile = JSON.parse(userProfile);
        setUserProfile(userProfile);
        userEmail = userProfile.userEmail;
        setUserEmail(userEmail);
        userName = userProfile.userName;
        setUserName(userName)

        getUserData()
        getRouteData()
        getSiteData()

        if (id > 0) {
            getDispatch()
        } else {
            handleDispatch()
        }

    }, [])

    const getDispatch = () => {
        const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/dispatch/" + id
        axios.get(MOBILESURETY_SCHEDULE_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    filteredRows = rows;
                    setFilteredRows(filteredRows)
                    setDisable(false)
                } else {
                    errorMessage()
                }
            })
    }

    const getUserData = () => {
        const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/employee/basic/" + userName
        axios.get(MOBILESURETY_SCHEDULE_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    userData = res.data.data
                    setUserData(userData);
                } else {
                    errorMessage()
                }
            })
    }

    const getSiteData = () => {
        const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/sites/basic"
        axios.get(MOBILESURETY_SCHEDULE_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    siteData = res.data.data
                    setSiteData(siteData);
                } else {
                    errorMessage()
                }
            })
    }

    const getRouteData = () => {
        const MOBILESURETY_SCHEDULE_URL = config.API_URL + "/api/routes/basic"
        axios.get(MOBILESURETY_SCHEDULE_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    routeData = res.data.data
                    setRouteData(routeData);
                } else {
                    errorMessage()
                }
            })
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const deleteDispatches = () => {
        const MOBILESURETY_URL = config.API_URL + "/api/dispatch/delete/" + recordId + "/" + userName
        const token = config.TOKEN
        axios.get(MOBILESURETY_URL, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                {
                    if (res.data.successCode === 0) {
                        deleteMessage()
                        handleDispatch()
                    } else {
                        errorContactMessage()
                    }
                    setTimeout(() => { setDeletePopup(false) }, 3000)
                }
            })
    }

    const openDeletePopup = (id) => {
        recordId = id;
        setRecordId(recordId)
        deletePopup = true;
        setDeletePopup(deletePopup)
    }

    const handleDispatch = () => {
        var postData = {
            "startDate": startDate,
            "endDate": endDate,
            "userId": userId,
            "siteId": siteId,
            "routeId": routeId
        }

        const MOBILESURETY_URL = config.API_URL + "/api/dispatch/search"
        const token = config.TOKEN

        axios.post(MOBILESURETY_URL, postData, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    filteredRows = rows;
                    setFilteredRows(rows);
                } else {
                    errorMessage()
                }
            })
    }

    const icons = (filteredRows) => {
        if (!filteredRows.pfDataId)
            return (
                <div>
                    <div className="actionListEditIconPosition">
                        <Tooltip title="Edit" aria-label="edit">
                            <IconButton className="actionBtn" aria-label="edit" onClick={() => { navigate('/dispatches/edit/' + filteredRows.id) }}>
                                <EditIcon className="actionIcon" />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className="actionApproveIconPosition">
                        <Tooltip title="Approve" aria-label="Approve">
                            <IconButton className="actionBtn" aria-label="Approve" onClick={() => approveForm(filteredRows, "Approved")}>
                                <CheckIcon className="approveActionIcon" />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className="actionRejectIconPosition">
                        <Tooltip title="Reject" aria-label="Reject">
                            <IconButton className="actionBtn" aria-label="Reject" onClick={() => openRejectPopup(filteredRows)}>
                                <ClearIcon className="actionIcon" />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            )
    }

    const openRejectPopup = (filteredRows) => {
        scheduleId = filteredRows.id;
        setScheduleId(scheduleId);
        approvePopup = true;
        setApprovePopup(approvePopup);
    }

    const closeRejectPopup = () => {
        approvePopup = false;
        setApprovePopup(approvePopup);
    }

    const approveForm = (filteredRows, string) => {
        var postData = {
            "userName": userEmail,
            "action": string,
            "id": filteredRows.id
        }
        approveReject(postData, string)
    }

    const rejectForm = (string) => {
        var postData = {
            "userName": userEmail,
            "action": string,
            "id": scheduleId
        }
        approveReject(postData, string)
    }

    const approveReject = (postData, string) => {

        const MOBILESURETY_URL = config.API_URL + "/api/dispatch/approval"
        const token = config.TOKEN

        axios.post(MOBILESURETY_URL, postData, {
            headers: {
                'Authorization': `Basic ${token}`
            }
        })
            .then((res) => {
                if (res.data.successCode === 0) {
                    if (string == "Approved") {
                        approveMessage()
                    }
                    else {
                        rejectMessage()
                        setTimeout(() => {
                            approvePopup = false;
                            setApprovePopup(approvePopup);
                        }, 5000)
                    }
                    getDispatch()
                } else {
                    if (string == "Approved") {
                        errorMessage()
                    } else {
                        errorMessage()
                        setTimeout(() => {
                            approvePopup = false;
                            setApprovePopup(approvePopup)
                        }, 2000)
                    }
                }
            })
    }

    return (

        <TableWrapper>
            <ToastContainer theme='dark' />
            <div className={`${classes.root} materialTableStyle`}>
                <div className="filterRow">
                    <Autocomplete
                        options={userData}
                        className="filterAutocomplete"
                        getOptionLabel={(option) => option.userName}
                        onChange={(event, employee) => {
                            employee != null ? setUserId(employee.id) : setUserId(null)
                        }}
                        renderInput={(params) => <TextField  {...params} fullWidth label="Select User" variant="filled" />
                        }
                    />
                    <Autocomplete
                        options={siteData}
                        className="filterAutocomplete"
                        getOptionLabel={(option) => option.projectName}
                        onChange={(event, site) => {
                            site != null ? setSiteId(site.id) : setSiteId(null)
                        }}
                        renderInput={(params) => <TextField  {...params} fullWidth label="Select Site" variant="filled" />
                        }
                    />
                    <div>
                        <FilterInput style={{ height: "35px" }} placeholder="Start Date(yyyy-mm-dd)" type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} />
                    </div>
                    <div>
                        <FilterInput style={{ height: "35px" }} placeholder="End Date(yyyy-mm-dd)" type="date" value={endDate} onChange={(event) => setEndDate(event.target.value)} />
                    </div>
                    <span>
                        <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={handleDispatch}>
                            Search
                        </Button>
                    </span>
                </div>
                <TableContainer>
                    <Dialog open={approvePopup} closeonescape="true" fullWidth={true} maxWidth="sm" >
                        <TableWrapper>
                            <DialogTitle>
                                <div className="text-right">
                                    <FontAwesomeIcon icon={faWindowClose} className="closeIcon" onClick={closeRejectPopup} />
                                </div>
                                Reject
                            </DialogTitle>
                            <DialogContent className="dialogStyle">
                                <div className={`${classes.root} materialTableStyle`}>
                                    {/* <div className="filterRowUpdate">
                                            <TextField fullWidth multiline label="Notes" variant="standard" onChange={(event) => setNotes(event.target.value)} />
                                        </div> */}
                                </div>
                                <DialogActions>
                                    <Grid container spacing={4} className="mt-3">
                                        <Grid item xs={12} sm={12} md={12} className="text-center">
                                            <Button type="submit" disabled={disable} variant="contained" color="primary" className="noShadow addBtn" onClick={() => rejectForm("Rejected")}>
                                                Confirm
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </DialogActions>
                                <ToastContainer theme='dark' />
                            </DialogContent>
                        </TableWrapper>
                    </Dialog>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>

                            {stableSort(filteredRows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((filteredRows, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={filteredRows.id}
                                        >
                                            <TableCell align="left">
                                                {filteredRows.dispatchDate != null ? filteredRows.dispatchDate = moment(Date.parse(filteredRows.dispatchDate)).format('MM/DD/YYYY hh:mm A') : ""}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.siteName}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.userName}
                                            </TableCell>
                                            <TableCell align="left">
                                                {filteredRows.formName}
                                            </TableCell>
                                            <TableCell align="left">
                                                {icons(filteredRows)}
                                                {filteredRows.pfDataId}
                                                {filteredRows.showDelete !== false && (
                                                    <div className="actionListDeleteIconPosition">
                                                        <Tooltip title="delete" aria-label="delete">
                                                            <IconButton className="actionBtn" aria-label="delete" onClick={() => { openDeletePopup(filteredRows.id) }}>
                                                                <DeleteIcon className="actionIcon" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Dialog open={deletePopup} closeonescape="true" maxWidth="true">
                                                            <TableWrapper>
                                                                <DialogContent className='dialogStyle'>
                                                                    <div className={`${classes.root} materialTableStyle`}>
                                                                        Do you want to delete the record?
                                                                    </div>
                                                                    <DialogActions>
                                                                        <Grid container spacing={4} className="mt-1">
                                                                            <Grid item xs={12} sm={12} md={12} className="text-center">
                                                                                <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => { setDeletePopup(false) }}>
                                                                                    No
                                                                                </Button>&nbsp;&nbsp;
                                                                                <Button type="button" variant="contained" color="primary" className="noShadow addBtn" onClick={() => { deleteDispatches() }}>
                                                                                    Yes
                                                                                </Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </DialogActions>
                                                                </DialogContent>
                                                            </TableWrapper>
                                                        </Dialog>
                                                    </div>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className="paginationLabel"
                    rowsPerPageOptions={[50, 100, 150]}
                    component="div"
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </TableWrapper>
    );
}


